import React, { Component } from "react"
import { connect } from 'react-redux'
import moment from 'moment'
import $ from 'jquery'
import { Div, Input, DatePicker, Select, TextArea, DropDownList, InputDecimal } from "../core";
import utilityHelper from '../../helpers/helperUtil'
import { Constants, MessageText, Storage } from '../../configs'
import { msg } from '../Notifications/MsgBox';
import { async } from "q";
import {
    getAllUnitReviewerAction,
    createUnitReviewerAction,
    updateUnitReviewerAction
} from "../../redux/actions/DepartmentMapAction";
import { getBusinessPlaceAction } from "../../redux/actions/MasterAction";

class DepartmentManageModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            ...props,
            docType: '',
            departmentManage: {},
            business_places: []
        }

        this.handleChange = this.handleChange.bind(this)
        this.saveDepartmentManage = this.saveDepartmentManage.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }

    componentDidMount() {
        const user = Storage.getUser()
        this.props.getAllUnitReviewer()
        this.props.getBusinessPlace()
            .then((response) => { this.setState({ business_places: response.data }) })
    }

    async componentWillReceiveProps(nextProps) {

        if (nextProps) {
            let departmentManage = nextProps.departmanageModal

            if (departmentManage.index !== "") {
                departmentManage.item = this.props.unitreviewerAll[departmentManage.index]
            } else {

                departmentManage.item = {
                    business_Place_Default: "",
                    department: "",
                    email_Response: "",
                    unit_Code: "",
                    unit_Description: "",
                }
            }

            let docType = ''

            await this.setState({
                departmentManage: {
                    index: departmentManage.index,
                    item: departmentManage.item
                }
            })
        }

        $(function () {
            window.onComponentDidMount()
        })
    }

    closeModal() {
        this.setState({
            departmentManage: {
                item: {},
                index: ''
            }
        })

        window.$('#departmentManage').modal('hide')

    }

    setOrg_Unit() {
        const { org_unit } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(org_unit, "unitcode", "unitabbr", "unitcode")

        return result
    }

    setUnitReviewer() {
        const { unitreviewerAll } = this.props
        let result = null
        result = utilityHelper.toSelectList_CombineFields(unitreviewerAll, "unit_Code", "unit_Description", "unit_Code")

        return result
    }

    async handleChange(event) {
        // console.log("handleChange", event.target
        const target = event.target;
        const valid = event.target.validity.valid
        let value = target.type === 'checkbox' ? (target.checked ? 1 : 0) : target.value;
        const name = target.name;

        if (valid) {

            await this.setState({
                departmentManage: {
                    ...this.state.departmentManage,
                    item: {
                        ...this.state.departmentManage.item,
                        [name]: value,
                    }
                }
            })

        } else {
            return
        }
    }

    validateDepartmentManageItem() {
        const { departmentManage } = this.state

        let msgvalidate = ""
        if (!departmentManage.item.unit_Code) {
            msgvalidate += "กรุณาระบุ UnitCode <br/>"
        }
        if (!departmentManage.item.unit_Description) {
            msgvalidate += "กรุณาระบุ UnitDescription <br/>"
        }
        if (!departmentManage.item.business_Place_Default) {
            msgvalidate += "กรุณาระบุ BusinessPlace <br/>"
        }
        if (!departmentManage.item.s_pgrp) {
            msgvalidate += "กรุณาระบุ PurGroup From <br/>"
        }
        if (!departmentManage.item.e_pgrp) {
            msgvalidate += "กรุณาระบุ PurGroup To <br/>"
        }
        if (departmentManage.item.s_pgrp && departmentManage.item.e_pgrp) {
            let s_pgrp = utilityHelper.parseFloat(departmentManage.item.s_pgrp)
            let e_pgrp = utilityHelper.parseFloat(departmentManage.item.e_pgrp)
            if (s_pgrp > e_pgrp) {
                msgvalidate += "กรุณาระบุ PurGroup ให้ถูกต้อง <br/>"
            }
        }

        if (departmentManage.item.email_Response) {

            //var mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            const email_Response_array = departmentManage.item.email_Response.split(';')
            let checkmail = false
            email_Response_array.forEach((itememail, index) => {

                var trimMail = itememail.replace(/^\s+|\s+$/g, '');
                if (trimMail && !(trimMail.match(mailformat))) {
                    checkmail = true
                }
            })
            if (checkmail) {
                msgvalidate += "กรุณาระบุ E-mail ให้ถูกต้อง<br/>"
            }

        }

        if (departmentManage.index === "" && departmentManage.item.unit_Code) {
            const { unitreviewerAll } = this.props
            let objdepartment = unitreviewerAll.find(f => f.unit_Code == departmentManage.item.unit_Code)
            if (objdepartment) {
                msgvalidate += "ไม่สามารถบันทึกข้อมูลได้ <br/>เนื่องจากพบว่ามี UnitCode นี้แล้วในระบบ"
            }
        }

        if (msgvalidate) {
            return { error_message: msgvalidate }
        }
        return null
    }

    async saveDepartmentManage() {
        let errors = []
        let _validateUser = this.validateDepartmentManageItem()
        if (_validateUser !== null) {
            errors.push(_validateUser)
        }
        let error_messages = []
        if (errors.length > 0) {
            errors.forEach((error, index) => {
                error_messages.push(error.error_message)
            })
            msg.error(error_messages.join('<br/>'))
        }
        else {
            if (this.state.departmentManage.index === "") {
                msg.showConfirm("Confirm",
                    MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_CONFIRM_CREATE,
                    async () => {
                        msg.hideConfirm()
                        await this.props.createUnitReviewer(this.state.departmentManage.item)
                        if (this.props.unitReviewerIsSuccess) {
                            msg.success(MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_SUCCESS_CREATE)
                            $(function () {
                                window.onSavePopupDepartmentManage()
                                window.$('#departmentManage').modal('hide')
                            })
                        } else {
                            msg.error(this.props.departmanageErrorMsg)
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )

            } else {
                msg.showConfirm(
                    "Confirm",
                    MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_CONFIRM_UPDATE,
                    async () => {
                        msg.hideConfirm()
                        await this.props.updateUnitReviewer(this.state.departmentManage.item)
                        if (this.props.unitReviewerIsSuccess) {
                            msg.success(MessageText.PAGE.DEPARTMENTMANAGE.POPUP_MSG_SUCCESS_UPDATE)
                            $(function () {
                                window.onSavePopupDepartmentManage()
                                window.$('#departmentManage').modal('hide')
                            })
                        } else {
                            msg.error(this.props.departmanageErrorMsg)
                        }
                    },
                    () => {
                        msg.hideConfirm()
                        console.log("On Cancel")
                    },
                    () => {
                        console.log("On Closed")
                    }
                )
            }
        }
    }

    render() {
        const { departmentManage, business_places } = this.state
        const roleAdmin = Storage.getRoleAdmin()
        

        return (
            <div className="modal fade sp-modal rrs-modal" id="departmentManage" tabIndex={-1} role="dialog" aria-labelledby="userModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="userModalLabel">แสดงรายละเอียด</h5>
                            <button type="button" className="close" onClick={this.closeModal} data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        {this.state.departmentManage.item && (<div className="modal-body">
                            <div className="rrs-detail-data sp-table-container">
                                <div id="div_UserInfo" className="rrs-detail">

                                    <div className="rrs-detail pt-2 pb-3 px-3 item-information">

                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label">หน่วยงานจัดหา</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.unit_Code}`}
                                                            type="text"
                                                            name="unit_Code"
                                                            defaultValue={departmentManage.item.unit_Code}
                                                            className="unit_Code"
                                                            id="unit_Code"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="departmentManage.unit_Code"
                                                            autocomplete="off"
                                                            maxlength="8"
                                                            disabled={roleAdmin ? false : true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="sapUser" className="rrs-label">ชื่อย่อหน่วยงานจัดหา</label>
                                                    <div className="rrs-detail-data">
                                                        <Input
                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.unit_Description}`}
                                                            type="text"
                                                            name="unit_Description"
                                                            defaultValue={departmentManage.item.unit_Description}
                                                            className="uniunit_Description_Code"
                                                            id="unit_Description"
                                                            onBlur={this.handleChange}
                                                            doctype={this.state.docType}
                                                            tagid="departmentManage.unit_Description"
                                                            autocomplete="off"
                                                            maxlength="50"
                                                            disabled={roleAdmin ? false : true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label">Bus.place/sectn</label>
                                                    <div className="rrs-detail-data">
                                                        <Select
                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.business_Place_Default}`}
                                                            name="business_Place_Default"
                                                            defaultValue={departmentManage.item.business_Place_Default}
                                                            onChange={this.handleChange}
                                                            disabled={roleAdmin ? false : true}
                                                        >
                                                            <option>กรุณาเลือก...</option>
                                                            {business_places && business_places.map((businessPlaces, index) => (
                                                                businessPlaces.businesS_PLACE.match(/H.*/) && (
                                                                    <option
                                                                        key={index}
                                                                        value={businessPlaces.businesS_PLACE}>
                                                                        {businessPlaces.businesS_PLACE + " : " + businessPlaces.description}
                                                                    </option>
                                                                )
                                                            ))}

                                                        </Select>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label">Purch.Group</label>
                                                    <div className="rrs-detail-data">
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="rrs-form">
                                                                    <div className="rrs-detail-data">
                                                                        <InputDecimal
                                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.s_pgrp}`}
                                                                            doctype={this.state.docType}
                                                                            tagid="departmentManage.s_pgrp"
                                                                            type="text"
                                                                            name="s_pgrp"
                                                                            pattern="[0-9]*"
                                                                            defaultValue={departmentManage.item.s_pgrp}
                                                                            className="form-control text-right"
                                                                            id="s_pgrp"
                                                                            onBlur={this.handleChange}
                                                                            inputMode="decimal"
                                                                            step="0"
                                                                            floatingPoint={0}
                                                                            autocomplete="off"
                                                                            disabled={roleAdmin ? false : true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-1"><label htmlFor="unitCode" className="rrs-label"> - </label></div>
                                                            <div className="col-md-4">
                                                                <div className="rrs-form">
                                                                    <div className="rrs-detail-data">
                                                                        <InputDecimal
                                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.e_pgrp}`}
                                                                            doctype={this.state.docType}
                                                                            tagid="departmentManage.e_pgrp"
                                                                            type="text"
                                                                            name="e_pgrp"
                                                                            pattern="[0-9]*"
                                                                            defaultValue={departmentManage.item.e_pgrp}
                                                                            className="form-control text-right"
                                                                            id="e_pgrp"
                                                                            onBlur={this.handleChange}
                                                                            inputMode="decimal"
                                                                            step="0"
                                                                            floatingPoint={0}
                                                                            autocomplete="off"
                                                                            disabled={roleAdmin ? false : true}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-2"></div>
                                            <div className="col-md-8">
                                                <div className="rrs-form">
                                                    <label htmlFor="unitCode" className="rrs-label">รายชื่อ E-mail ใช้สำหรับส่งแจ้งเตือนในระบบ RSS</label>
                                                    <div className="rrs-detail-data">

                                                        <textarea
                                                            cols={3}
                                                            rows={5}
                                                            key={`departmentManageModal_${departmentManage.item.unit_Id}_${departmentManage.item.email_Response}`}
                                                            name="email_Response"
                                                            onBlur={this.handleChange}
                                                            id="email_Response"
                                                            defaultValue={departmentManage.item.email_Response != null ? departmentManage.item.email_Response : ''}
                                                            className="form-control rrs-textarea"
                                                            maxlength="400"
                                                            disabled={roleAdmin ? false : true}
                                                        />

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>


                                <div className="rrs-detail py-1">
                                    <div className="row sp-table-content-footer">
                                        <div className="col-10 sp-header-button-panel2"></div>
                                        <div className="col-2 sp-header-button-panel2">
                                            <a href="#" className="sp-btn-icon btn-del" onClick={() => this.closeModal()} data-dismiss="modal">
                                                <i className="icon btn-order-delete" />
                                                <span className="sp-btn-icon-label">Close</span>
                                            </a>

                                            <a href="#departmentmanage" className="sp-btn-icon" onClick={() => this.saveDepartmentManage()} style={{ display: roleAdmin ? "" : "none" }}>
                                                <i className="icon btn-order-savedraft" />
                                                <span className="sp-btn-icon-label">Save</span>
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </div>
                </div>
            </div >
        )

    }
}

const mapStateToProps = state => {
    const { MasterRedux, DepartmentMapRedux } = state
    return {
        org_unit: MasterRedux.org_unit,
        unitreviewerAll: DepartmentMapRedux.unitreviewerAll,
        departmanageModal: DepartmentMapRedux.departmanageModal,
        departmanageErrorMsg: DepartmentMapRedux.departmanageErrorMsg,
        unitReviewerIsSuccess: DepartmentMapRedux.unitReviewerIsSuccess,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAllUnitReviewer: () => dispatch(getAllUnitReviewerAction()),
        createUnitReviewer: (data) => dispatch(createUnitReviewerAction(data)),
        updateUnitReviewer: (data) => dispatch(updateUnitReviewerAction(data)),
        getBusinessPlace: () => dispatch(getBusinessPlaceAction()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DepartmentManageModal)